import { Navigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Skeleton } from "~/components/ui/skeleton";
import { useProjectContext } from "./useProjectContext";

export const ProjectChatIndex = () => {
  const { projectId, conversations } = useProjectContext();

  if (conversations === undefined) {
    return (
      <div
        className="flex flex-1 flex-col gap-3 overflow-y-auto p-6"
        role="status"
        aria-label="Loading conversations"
        aria-busy="true"
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex flex-col gap-2 rounded-md border border-border p-4">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-2/3" />
          </div>
        ))}
      </div>
    );
  }

  const latest = conversations[0];
  if (latest) {
    return <Navigate to={`c/${latest.id}`} replace />;
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 overflow-y-auto p-6 text-center">
      <MessageSquare className="size-10 text-muted-foreground" aria-hidden="true" />
      <p className="text-sm font-medium text-foreground">No conversations</p>
      <p className="max-w-xs text-xs text-muted-foreground">
        Conversations you start in this project will appear here.
      </p>
    </div>
  );
};
